export default {
  "widget.defaultTitle": "Fale conosco",
  "widget.defaultSubtitle": "Estamos aqui para ajudar",
  "widget.defaultGreeting": "Olá! Como podemos ajudar você hoje?",
  "chat.close": "Fechar chat",
  "chat.open": "Abrir chat",
  "chat.expand": "Expandir chat",
  "chat.collapse": "Recolher chat",
  "chat.conversationEnded": "Esta conversa foi encerrada",
  "chat.startNew": "Iniciar Nova Conversa",
  "chat.poweredBy": "Desenvolvido por",
  "chat.conversationClosed": "Conversa Encerrada",
  "chat.aiLabel": "Assistente de IA",
  "input.placeholder": "Digite uma mensagem...",
  "input.send": "Enviar mensagem",
  "error.sendFailed": "Não foi possível enviar sua mensagem. Tente novamente em instantes.",
  "error.messageTooLong": "Sua mensagem é muito longa. Encurte-a e tente novamente.",
  "chat.teamMember": "Um membro da equipe",
  "chat.agentJoined": "{name} entrou na conversa",
  "chat.agentLeft": "{name} saiu da conversa",
  "chat.agentReturnedToAi":
    "{name} saiu da conversa. Você está falando com o assistente de IA novamente.",
  "availability.open": "Aberto agora",
  "availability.backAt": "Retorno: {when}",
  "availability.closed": "Fora do horário agora",
  "waiting.title": "Aguardando uma pessoa",
  "waiting.typical": "Costuma responder em {time}",
  "waiting.alerted": "Avisamos a equipe.",
  "waiting.closed": "A equipe volta {when}. Até lá, o assistente de IA pode continuar ajudando.",
  "waiting.minutes": "~{n} min",
  "waiting.hours": "~{n} h",
  "contact.prompt":
    "Deixe seu e-mail e enviaremos a resposta da equipe para lá se você tiver saído.",
  "contact.label": "E-mail",
  "contact.placeholder": "voce@exemplo.com",
  "contact.submit": "Avise-me",
  "contact.consent": "Usaremos seu e-mail apenas para responder a esta conversa.",
  "contact.saved": "Obrigado! Se você tiver saído quando a equipe responder, enviaremos um e-mail.",
  "contact.failed": "Não foi possível salvar seu e-mail. Verifique e tente novamente.",
  "input.attach": "Anexar foto ou PDF",
  "error.fileTooLarge": "Esse arquivo é grande demais. Fotos e PDFs de até 10 MB.",
  "error.fileType": "Você pode enviar fotos (JPG, PNG, GIF, WebP) ou PDFs.",
  "error.fileFailed": "Não foi possível enviar seu arquivo. Tente outro.",
  "attachment.photo": "Foto",
  "attachment.file": "Arquivo",
  "attachment.sending": "Enviando...",
  "error.verificationFailed": "Não conseguimos verificar sua mensagem. Atualize a página e tente novamente.",
  "challenge.label": "Verificação de segurança",
  "challenge.prompt": "Uma verificação rápida de segurança antes de enviar sua mensagem.",
  "csat.defaultQuestion": "Como você avalia o atendimento que recebeu hoje?",
  "csat.thankYou": "Obrigado pelo seu feedback!",
} as const;
